module.exports = __webpack_public_path__ + "static/media/pos_slideshow3.642110d8.jpg";